/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { DatabaseSnapshot } from '@angular/fire/compat/database';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import {
	CustomFieldDropDownDefinition,
	ICustomFieldDropDownDefinition,
} from 'src/app/app-data/models/CustomFieldDropDownDefinition';
import { LocalAction } from '../base/LocalSnapshot';

export class CustomFieldDropDownDefinitionList extends FancyFirebaseSplitDataList<
	ICustomFieldDropDownDefinition,
	DefaultSplitDataRenderType,
	CustomFieldDropDownDefinition
> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: LocalAction<DatabaseSnapshot<any>>) {
		const definition = new CustomFieldDropDownDefinition(action.payload.key);
		if (action.type === 'child_added') {
			// firebase
			definition.databaseUpdate(action.payload.val());
		} else if (action.type === 'add_item') {
			// local
			definition.localDatabaseUpdate(action.payload.val());
		}
		return definition;
	}
}
